<template src="./Pagamento.html"></template>
<style lang="scss" scoped src="./Pagamento.scss"></style>

<script>
import { VDialog, VCard, VCardTitle, VCardText } from 'vuetify/lib'
import service from '../../../services/qrcode.service';
import { redirect } from '../../../helpers/helpers'
import { myUser } from '../../../services/user.service'
import { types } from '../../../store';
import * as helper from '../helper';
import ConfirmRechargeModal from '../../../components/ConfirmRechargeModal.vue'
export default {
  name: 'bilhete-especial-pagamento',
  props:{
    data:{
      type: Object
    },
  },
  components: {
    ConfirmRechargeModal,
    VDialog,
    VCard,
    VCardTitle,
    VCardText
  },
  data() {
    return {
      loaded: false,
      service,
      helper,
      paymentCards: [],
      groupSelected: [],
      cartaoSelect: null,
      finalizado: false,
      processing: false,
      urlPayment: {
        open: false,
        link: null
      },
      confirmModal: {
          open: false,
          data: {
            Value: null,
            CreditCard: null,
            Promotion: null,
            AceitePromocao: false
          }
        }
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    groups() {
      return this.$store.state.qrcode_groups || [];
    },
    selected() {
      return this.$store.state.qrcode_selected || []
    },
    validPaymentCards(){
      let novo = [
        { id: 'novo', cardNumber: 'Novo cartão' },
        { id: 'pix', cardNumber: 'PIX' },
      ];
      return this.paymentCards ? [...novo, ...this.paymentCards.filter(c=>c.cardNumber && c.active)] : novo;
    },
    valorTotal() {
      return this.selected.map(x => x.tarifaAtiva.valor).reduce((acc, cur) => acc + cur, 0);
    },
    qtdTickets() {
      return this.selected.map(x => x.permiteUsoDuplicidade ? 2 : 1).reduce((acc, cur) => acc + cur, 0);
    },
    valorPorTicket() {
      console.log(this.qtdTickets, this.valorTotal);
      return this.qtdTickets ? this.valorTotal / this.qtdTickets : 0;
    },
    valid() {
      return this.cartaoSelect && this.validPaymentCards.length && this.selected.length;
    }
  },
  methods: {
    count(bilhete) {
      return this.selected.filter(x => x.idProduto == bilhete.idProduto).length;
    },
    revisar() {
      return this.$router.back();
    },
    modalConfirmacao() {
      let activeCard = this.validPaymentCards.find(v => v.id == this.cartaoSelect);
      if(['pix','novo'].indexOf(this.cartaoSelect) == -1)
        if(!activeCard) return;
      this.confirmModal = {
        open: true,
        data: {
          Type: 'qrcode',
          QtdPassagens: this.selected.length,
          Value: this.valorTotal.toString(),
          CreditCard: activeCard.cardNumber.toString(),
          Promotion: null,
          AceitePromocao: false
        }
      }
    },
    fecharModal() {
      this.urlPayment.open = false;
      this.urlPayment.iframe = null;
      redirect("bilhete-especial",this);
    },
    fazerRecarga(){
      this.processing = true;
      this.confirmModal = { open: false, data: null };
      service.getQRCodesComprar({
        valorTotal: this.valorTotal,
        selected: this.selected,
        cartaoSelect: this.cartaoSelect
      }).then(({ data }) => {
        if(data.urlAuthDebit) {
          this.urlPayment.link = data.urlAuthDebit;
          this.urlPayment.open = true;
          this.finalizado = true;
          this.$store.dispatch(types.SET_QRCODE_SELECTED, []);
        }
      }).catch(err => {
        this.$store.dispatch(types.MODAL_ALERT, { dialog: true, title: "Erro", message: "Compra dos bilhetes não efetuada" });
        console.log(err);
      }).finally(() => {
        this.processing = false;
      })
    }
  },
  mounted(){
    if(!sessionStorage.getItem("giro-token")) 
      redirect("login",this);

    if(!this.current || !this.selected.length) {
      this.$router.push({ name: 'home' });
      return;
    }
    this.finalizado = false;
    this.urlPayment = { open: false, link: null };
    myUser().then(res => {
      this.paymentCards = res.data.paymentCards;
      this.groupSelected = [];
      this.selected.forEach((v) => {
        if(!this.groupSelected.find(x => x.idProduto  == v.idProduto)) {
          this.groupSelected.push(v);
        }
      });
    }).catch(() => {
      redirect("login",this);
    });
  }
}
</script>
